import { Link } from 'react-router-dom';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { MainContent } from '../../../components/Card/ReviewCard';
import CompanyLogo from '../../../components/CompanyLogo/CompanyLogo';

const EmailVerify = () => {
  return (
    <SignUpContainer>
      <CompanyLogo1>
        <CompanyLogo />
      </CompanyLogo1>
      <OtpContent>
        <MainContent1>
          <MainContent>Congratulations, Email Verified</MainContent>
        </MainContent1>
        <FormSubmitButton type="submit" className="contact1">
          <Linkk to="/u/dashboard">Home</Linkk>
        </FormSubmitButton>
      </OtpContent>
    </SignUpContainer>
  );
};

export default EmailVerify;

const SignUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh; /* Adjust as needed for your layout */
  height: fit-content;
`;

const OtpContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1px;
  padding: 0.5rem 2rem 0.2rem 2rem;
  width: 600px;
  align-items: center;
  background-color: white;
  box-shadow: 0 7px 8px rgba(0, 0, 0, 0.1);
`;

const MainContent1 = styled.div`
  color: ${({ theme }) => theme.palette.greyGrey1};
  margin-bottom: 1.5rem;
`;

const CompanyLogo1 = styled.div`
  margin-bottom: 2rem;
`;

// const Span = styled.span`
//   background-color: ${({ theme }) => theme.palette.greyGrey1};
// `;

const Linkk = styled(Link)`
  text-decoration: none;
  color: white;
`;
